import type { LucideIcon } from "lucide-react";
import {
  Bell,
  Bookmark,
  Briefcase,
  Building2,
  CalendarDays,
  ClipboardList,
  FileText,
  Handshake,
  Home,
  LayoutGrid,
  MessageCircle,
  Newspaper,
  Settings,
  Users,
} from "lucide-react";

export type NavItem = {
  label: string;
  href: string;
  icon: LucideIcon;
};

export type NavSection = {
  title: string;
  items: NavItem[];
};

export const mainNavigation: NavSection[] = [
  {
    title: "",
    items: [
      { label: "Kezdőlap", href: "/", icon: Home },
      { label: "Hírfolyam", href: "/feed", icon: Newspaper },
      { label: "Közösségek", href: "/communities", icon: Users },
      { label: "Chat", href: "/chat", icon: MessageCircle },
      { label: "Események", href: "/events", icon: CalendarDays },
      { label: "Mentett bejegyzések", href: "/saved", icon: Bookmark },
    ],
  },
  {
    title: "Szolgáltatások",
    items: [
      { label: "Szolgáltatások", href: "/services", icon: LayoutGrid },
      { label: "Ajánlataim", href: "/services/offers", icon: Handshake },
      { label: "Igényeim", href: "/services/requests", icon: ClipboardList },
      {
        label: "Aktív szolgáltatásaim",
        href: "/services/active",
        icon: Briefcase,
      },
      { label: "Dokumentumaim", href: "/services/documents", icon: FileText },
    ],
  },
  {
    title: "",
    items: [
      { label: "Értesítések", href: "/notifications", icon: Bell },
      { label: "Praxisaim", href: "/practices", icon: Building2 },
      { label: "Beállítások", href: "/settings", icon: Settings },
    ],
  },
];
